
<div class="page">
<div>

    <nav>
      <app-email-preference-checker></app-email-preference-checker>
      <app-browser-checker></app-browser-checker>
      <app-navigation-bar></app-navigation-bar>
    </nav>

      <app-login-sign-up *ngIf="display" style="z-index: 1000;"></app-login-sign-up>
      <main>
          <router-outlet></router-outlet>
      </main>
      
</div>
<div style="flex:1"></div>
<footer id="footer" class="footer">
    <app-footer-section></app-footer-section>
</footer>

</div>